module.exports = __webpack_public_path__ + "img/onboarding/default-avatar-welcome-39ce2a7d19b2fa6698f8c8d153174634.svg";